import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad11ERed11BBlack = () => <CrossRoad coords="2207.000000, 773.000000"/>;
export default CrossRoad11ERed11BBlack;
